module.exports = __webpack_public_path__ + "img/unlocked.86edbcdd.png";